import { isAuthorized } from 'utils/Auth'
import {
  EditorState,
} from 'draft-js'
import { createReducer } from '../../utils'

export const EMAIL_BY_ID_REQUEST = 'sherrinford/email/edit/EMAIL_BY_ID_REQUEST'
export const EMAIL_BY_ID_SUCCESS = 'sherrinford/email/edit/EMAIL_BY_ID_SUCCESS'
export const EMAIL_BY_ID_ERROR = 'sherrinford/email/edit/EMAIL_BY_ID_ERROR'

export const INPUT_TAG_REQUEST = 'sherrinford/email/edit/INPUT_TAG_REQUEST'
export const INPUT_TAG_SUCCESS = 'sherrinford/email/edit/INPUT_TAG_SUCCESS'
export const INPUT_TAG_ERROR = 'sherrinford/email/edit/INPUT_TAG_ERROR'

export const IS_LOADING = 'sherrinford/email/edit/IS_LOADING'
export const DATA = 'sherrinford/email/edit/DATA'

const initialState = {
  data: {
    id: '',
    subject: '',
    category: '',
    group: '',
    type: '',
    editor: EditorState.createEmpty(),
    template: '',
    content: '',
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
}

export default createReducer(initialState, {
  [EMAIL_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [EMAIL_BY_ID_SUCCESS]: (state, data) => {
    const { id, subject, category, group, type, template, content } = data

    return {
      ...state,
      data: {
        id,
        subject,
        category,
        group,
        type,
        template,
        content,
      },
      isLoading: false,
    }
  },
  [EMAIL_BY_ID_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),


  [INPUT_TAG_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [INPUT_TAG_SUCCESS]: (state, data) => {
    const { id, subject, category, group, type, template, content } = data

    return {
      ...state,
      data: {
        id,
        subject,
        category,
        group,
        type,
        template,
        content,
      },
      isLoading: false,
    }
  },
  [INPUT_TAG_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, email) => {
    const { data } = email
    return {
      ...state,
      data,
    }
  },
})

export const updateEmail = (data, id, cb) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      INPUT_TAG_REQUEST,
      INPUT_TAG_SUCCESS,
      INPUT_TAG_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/email/${id}`,
      payloads: data,
      authorization: `${token}`,
    },
    nextAction: (res) => {
      cb(res)
    },
  }
}

export const getEmailById = (id, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      EMAIL_BY_ID_REQUEST,
      EMAIL_BY_ID_SUCCESS,
      EMAIL_BY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/email/${id}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})
